export const getInitials = (
  user:
    | {
        first_name?: string;
        last_name?: string;
      }
    | undefined
) => {
  const firstInitial = user?.first_name
    ? user?.first_name.charAt(0).toUpperCase()
    : "";
  const lastInitial = user?.last_name
    ? user?.last_name.charAt(0).toUpperCase()
    : "";
  return `${firstInitial}${lastInitial}`;
};
